module.exports = __webpack_public_path__ + "static/media/wings eIP.bf5425df.png";